module.exports = __webpack_public_path__ + "img/project-state.d5581ea5.png";